var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"chips pl-2 pr-2",attrs:{"x-small":"","color":_vm.ChipsColor,"dark":_vm.ChipsColor === 'black'}},[_vm._v(" "+_vm._s(_vm.chipText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }